// extracted by mini-css-extract-plugin
export var card = "Timeline-module--card--2Pimx";
export var col = "Timeline-module--col--LV2Aw";
export var container = "Timeline-module--container--4fl+K";
export var leftCol = "Timeline-module--leftCol--CvGPw";
export var rightCol = "Timeline-module--rightCol--zbyt-";